import type { Theme } from '@mui/material';

export const getStackSx = (theme:Theme, withBorder:boolean) => {
  return {
    flex: '0 0 calc((100% - 3 * 24px) / 4)',
    background: theme.palette.white_to_white_grad,
    borderRadius: 6,

    display: 'grid',
    placeItems: 'center',
    p: 10,
    ...(withBorder && {
      background: 'white',
      border: `4px solid ${theme.palette.accent}`,
      boxShadow: `0 0 40px 0 ${theme.palette.accent}`,
    }),

  }
}